import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PrintingTemplateRenderer  {
    _originalTypeClassName = "zERP.BO.PrintingTemplateRenderer";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PrintingTemplateRenderer.translate = translateService;
}
this.PrintingTemplateRendererKey = null;
this._key = this.PrintingTemplateRendererKey = 0; 
}

static translate: TranslateService;
_key: any;
AccountingTemplate:any;
private _PrintingTemplateRendererKey:any;
get PrintingTemplateRendererKey(): any {
    return this._PrintingTemplateRendererKey;
  }
set PrintingTemplateRendererKey(value: any) {
    this._PrintingTemplateRendererKey = value;
    this._key = value;
  }
static setAccountingTemplate = ($this, value) => {
var oldValue = $this.AccountingTemplate;
$this.AccountingTemplate = value;
if (value != null) {
}
}

static SetParentTemplate($this: any, template: any): any{Domain.PrintingTemplateRenderer.setAccountingTemplate($this, template);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PrintingTemplateRendererKey == null || $this.PrintingTemplateRendererKey == 0;
            }


}